import Header from '@/components/Header';
import Footer from '@/components/Footer';
import HeroSection from './components/HeroSection';
import IntroVideoSection from './components/IntroVideoSection';
import GenericVsCustomSection from './components/GenericVsCustomSection';
import OutroVideoSection from './components/OutroVideoSection';
import FinalCtaSection from './components/FinalCtaSection';

export default function HomePage() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <IntroVideoSection />
        <GenericVsCustomSection />
        <OutroVideoSection />
        <FinalCtaSection />
      </main>
      <Footer />
    </>
  );
}